import React, { useEffect, useState } from 'react';
import { Icon } from '../icon/Icon';
import './Tooltip.scss';

interface TooltipProps {
  content: string;
  ariaName: string;
  position?:
    | 'bottomCenter'
    | 'bottomLeft'
    | 'bottomRight'
    | 'topCenter'
    | 'topLeft'
    | 'topRight';
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  position = 'topLeft',
  ariaName
}) => {
  const [twoLine, setTwoLine] = useState('');

  useEffect(() => {
    const splitContent = content.split(' ');
    const lastWord = splitContent[splitContent.length - 1];
    if (content.length > 45) {
      setTwoLine('ads-tooltip--two-line');
    } else if (content.length > 23) {
      if (lastWord.length !== 2) {
        setTwoLine('ads-tooltip--two-line');
      }
    }
  }, [content]);

  return (
    <span
      className="ads-tooltip"
      tabIndex={0}
      role="tooltip"
      aria-label={ariaName}
      data-testid="ads-tooltip"
    >
      <Icon name="informationOutline" size="ads-font-size-03" />

      {position === 'topCenter' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-top ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span className={`ads-tooltip__pointer ${twoLine}`} />
        </span>
      )}

      {position === 'topLeft' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-top ads-tooltip--show-top-left ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span
            className={`ads-tooltip__pointer ads-tooltip__pointer-top-left ${twoLine}`}
          />
        </span>
      )}

      {position === 'topRight' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-top ads-tooltip--show-top-right ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span
            className={`ads-tooltip__pointer ads-tooltip__pointer-top-right ${twoLine}`}
          />
        </span>
      )}

      {position === 'bottomCenter' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-bottom ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span className={`ads-tooltip__pointer ${twoLine}`} />
        </span>
      )}

      {position === 'bottomLeft' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-bottom ads-tooltip--show-bottom-left ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span
            className={`ads-tooltip__pointer ads-tooltip__pointer-bottom-left ${twoLine}`}
          />
        </span>
      )}

      {position === 'bottomRight' && (
        <span
          className={`ads-tooltip--show ads-tooltip--show-bottom ads-tooltip--show-bottom-right ${twoLine}`}
          data-testid="ads-tooltip__content"
        >
          {content}
          <span
            className={`ads-tooltip__pointer ads-tooltip__pointer-bottom-right ${twoLine}`}
          />
        </span>
      )}
    </span>
  );
};
